import React, { useState, useEffect, useContext, createContext } from "react";

const expandableContext = createContext();

export function GlobalExpandableManagerProvider({ children }) {
  const state = useProvideGlobalExpandableManager();
  return (
    <expandableContext.Provider value={state}>
      {children}
    </expandableContext.Provider>
  );
}

function useProvideGlobalExpandableManager() {
  const [shownItem, setShownItem] = useState(null);
  return { shownItem, setShownItem };
}

export const useGlobalExpandableManager = () => {
  const ctx = useContext(expandableContext);
  return ctx;
};
